import { ExperimentStore } from 'bernie-plugin-mobx';

import {
  createSearchAndFilterDisplayOptions,
  getDefaultRequestFields,
  mapOmnitureData,
  mapPropertySearchListings,
  mapSearchedDestination,
  mapSortAndFilter,
} from 'stores/adapters';
import { mapMap } from 'src/common/stores/adapters/bex-api/search/map-adapter';

import { HotelResultsViewModel } from 'models';

import { LodgingPwaPropertySearch, OperationResult } from '__generated__/api';

export const adaptPropertySearch = (
  bexApiResults: OperationResult<LodgingPwaPropertySearch.Query>,
  experiments?: ExperimentStore,
  sortAndFilterData?: any
): HotelResultsViewModel => {
  const { data, extensions } = bexApiResults;

  if (!data || !data.propertySearch) {
    return {};
  }

  const { propertySearch } = data;

  const { summary } = propertySearch;

  const loyaltyInfo = summary && summary.loyaltyInfo;

  return {
    defaultRequestFields: getDefaultRequestFields(
      propertySearch.criteria,
      propertySearch.shoppingContext && propertySearch.shoppingContext.multiItem && propertySearch.shoppingContext.multiItem.id,
      bexApiResults
    ),
    propertySearchListings: mapPropertySearchListings(data),
    loyaltyMessagingModel: loyaltyInfo,
    map: mapMap(data),
    multiItemSearchContext: propertySearch.multiItemSearchContext,
    omnitureData: mapOmnitureData(extensions.analytics),
    resultSectionHeadings: summary && summary.resultSectionHeadings,
    searchAndFilterDisplayOptions: createSearchAndFilterDisplayOptions(propertySearch.sortAndFilter),
    searchedDestination: mapSearchedDestination(data),
    sortAndFilter: mapSortAndFilter(sortAndFilterData ? sortAndFilterData : data?.propertySearch?.sortAndFilter),
    resultsSummary: summary && summary.resultsSummary,
    resultMessages: summary && summary.resultMessages,
    resultsHeading: summary && summary.resultsHeading,
    totalPropertyCount: summary && summary.matchedPropertiesSize,
    legalDisclaimer: propertySearch.legalDisclaimer,
    errorResponse: propertySearch.errorResponse,
    dialogErrorResponse: propertySearch.dialogErrorResponse,
    navigationTabs: propertySearch.navigationTabs,
    clickstreamEvents: propertySearch.clickstream,
  };
};
